import Component from '../inherited/Component'

export default class StickyPosition extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._currentScrollY = window.scrollY
    this._currentDirection = 'down'
    this._lastScrollY = 0
  }

  async mount () {
    this._assignVariables()

    this._setProperty()

    const observer = new MutationObserver((list, observer) => {
      this._setProperty()
    });
    observer.observe(this._elem, {
      subtree: true,
      childList: true
    });

    window.addEventListener('scroll', e => {
      this._assignVariables()
      this._setProperty()
    }, { passive: true })
  }

  _assignVariables () {
    this._currentScrollY = window.scrollY
    this._currentDirection = this._currentScrollY > this._lastScrollY ? 'down' : 'up'
    this._lastScrollY = window.scrollY
  }

  _setProperty () {
    let offset = window.innerHeight - this._elem.clientHeight

    let atBottom = this._elem.offsetTop === (this._elem.parentElement.clientHeight - this._elem.clientHeight)

    if (offset < 0 && this._currentDirection === 'down') {
      this._elem.style.setProperty('--sticky-offset',`${offset - 16}px`)
    } else {
      this._elem.style.setProperty('--sticky-offset', `0px`)
    }
  }
}